import $ from 'jquery';
import {breakpointDown, breakpointUp} from '../libs/Breakpoints';

export default {
    data() {
        return {
            breakpointDownSm:false,
            breakpointDownMd:false,
            breakpointDownLg:false,
            breakpointDownXl:false,
            breakpointDownXxl:false,
            breakpointUpSm:false,
            breakpointUpMd:false,
            breakpointUpLg:false,
            breakpointUpXl:false,
            breakpointUpXxl:false,
        };
    },
    watch:{
    },
    methods: {
        initValues(){
            this.breakpointDownSm = window.breakpointDownSm = breakpointDown('sm');
            this.breakpointDownMd = window.breakpointDownMd = breakpointDown('md');
            this.breakpointDownLg = window.breakpointDownLg = breakpointDown('lg');
            this.breakpointDownXl = window.breakpointDownXl = breakpointDown('xl');
            this.breakpointDownXxl = window.breakpointDownXxl = breakpointDown('xxl');

            this.breakpointUpSm = window.breakpointUpSm = breakpointUp('sm');
            this.breakpointUpMd = window.breakpointUpMd = breakpointUp('md');
            this.breakpointUpLg = window.breakpointUpLg = breakpointUp('lg');
            this.breakpointUpXl = window.breakpointUpXl = breakpointUp('xl');
            this.breakpointUpXxl = window.breakpointUpXxl = breakpointUp('xxl');
        }
    },
    created() {
        this.initValues()
        $(window).bind('resizeEndThrottle', () => {
            this.initValues()
        });

    }
};